import { post } from "../utils/http";
export default {
    async getNumTransactionGoodsByOpenId (param) {
      return await post('/transactionGoods/getNumTransactionGoodsByOpenId', param);
    },
  };